"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpringboardEngagementViewStoreContextProvider = exports.useSpringboardEngagementViewStoreContext = exports.ACTION_SPRINGBOARD_DISCOVERY_LOCALSTORAGE_KEY = void 0;
var React = __importStar(require("react"));
var zod_1 = require("zod");
var AuthenticationContext_1 = require("./AuthenticationContext");
var StoredState_1 = require("../StoredState/StoredState");
exports.ACTION_SPRINGBOARD_DISCOVERY_LOCALSTORAGE_KEY = "actionSpringboardDiscovery";
var SpringboardEngagementViewStoreContext = React.createContext(undefined);
var useSpringboardEngagementViewStoreContext = function () {
    var ctx = React.useContext(SpringboardEngagementViewStoreContext);
    if (!ctx) {
        throw new Error("useSpringboardViewStoreContext() must be used within a <SpringboardViewStoreContextProvider> component");
    }
    return ctx;
};
exports.useSpringboardEngagementViewStoreContext = useSpringboardEngagementViewStoreContext;
var SpringboardEngagementViewStoreContextProvider = function (_a) {
    var children = _a.children, enabled = _a.enabled, _b = _a.demoMode, demoMode = _b === void 0 ? false : _b, _c = _a.isInline, isInline = _c === void 0 ? false : _c;
    var isSignedIn = (0, AuthenticationContext_1.useAuthenticationContext)().isSignedIn;
    var sessionKey = "clerkUserWasActive";
    var _d = __read(React.useState(false), 2), showMenu = _d[0], setShowMenu = _d[1];
    var _e = __read((0, StoredState_1.useSessionStorage)({
        key: sessionKey,
        schema: zod_1.z.boolean(),
        default: false,
    }), 2), isAuthenticatedSession = _e[0], setIsAuthenticatedSession = _e[1];
    React.useEffect(function () {
        if (isSignedIn) {
            setIsAuthenticatedSession(true);
        }
    }, [isSignedIn]);
    React.useEffect(function () {
        if (isAuthenticatedSession || enabled) {
            setShowMenu(true);
        }
        else {
            setShowMenu(false);
        }
    }, [isAuthenticatedSession, enabled]);
    return (React.createElement(SpringboardEngagementViewStoreContext.Provider, { value: {
            demoMode: demoMode,
            showEngagementMenu: showMenu,
            isInline: isInline,
        } }, children));
};
exports.SpringboardEngagementViewStoreContextProvider = SpringboardEngagementViewStoreContextProvider;
